module.exports = __webpack_public_path__ + "31c4e721aee5eaa4286d1f42fd7933e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-32.png
// module id = 2059
// module chunks = 0